import { render, staticRenderFns } from "./ViewEconomicDataActionsDetailDialogComponent.vue?vue&type=template&id=6a9f43e7&scoped=true&lang=pug"
import script from "./ViewEconomicDataActionsDetailDialogComponent.vue?vue&type=script&lang=ts"
export * from "./ViewEconomicDataActionsDetailDialogComponent.vue?vue&type=script&lang=ts"
import style0 from "./ViewEconomicDataActionsDetailDialogComponent.vue?vue&type=style&index=0&id=6a9f43e7&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9f43e7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a9f43e7')) {
      api.createRecord('6a9f43e7', component.options)
    } else {
      api.reload('6a9f43e7', component.options)
    }
    module.hot.accept("./ViewEconomicDataActionsDetailDialogComponent.vue?vue&type=template&id=6a9f43e7&scoped=true&lang=pug", function () {
      api.rerender('6a9f43e7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Dialog/customDialogs/ViewEconomicDataActionsDetailDialogComponent.vue"
export default component.exports